// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"525":"6c42808c","642":"8e25cb73","675":"36873e73","774":"147c8e76","884":"730c6436","891":"d8cc60e0"}[chunkId] + ".chunk.js";
};